import { isExpired, decodeToken } from "react-jwt";
import { AccessTokenRepsonse, IDTokenRepsonse } from "../types/auth";

export const isTokenExpired = (token: string) => {
  return isExpired(token);
};

export const decodeJwtToken = (token: string): AccessTokenRepsonse | null => {
  return decodeToken(token);
};

export const decodeJwtIdToken = (token: string): IDTokenRepsonse | null => {
  return decodeToken(token);
};
